import { render, staticRenderFns } from "./DialogFieldDesc.vue?vue&type=template&id=c32e1502"
import script from "./DialogFieldDesc.vue?vue&type=script&lang=js"
export * from "./DialogFieldDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports